import React, { createContext, useState } from 'react'

export const AgencyContext =  createContext()

function AgencyContextProvider({children}) {
  const [agencyState, setAgencyState] = useState({
    branchId:"",
    spCode : "",
    spPh : "",
    spMail : "",
    supervisorName:"",
    supervisorMobile : "",
    supervisorDesignation : "",
    supervisorEmpCode: "",
    accessToken : "",
    refreshToken : "",
})

  return (
    <AgencyContext.Provider value={{agencyState,setAgencyState}}>
        {children}
    </AgencyContext.Provider>
  )
}

export default AgencyContextProvider